import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageExtender from '../../../redux/action/FJActionImageExtender';
import FJMobileImageExtenderCreation from './FJMobileImageExtenderCreation';
import { useDispatch, useSelector } from 'react-redux';

const FJMobileImageExtenderCreationContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const uploadImageInfo = useSelector(state => state.imageExtender.uploadImageInfo);

    const boardSize = useSelector(state => state.imageExtender.boardSize);
    const imageRect = useSelector(state => state.imageExtender.imageRect);
    const curRatioName = useSelector(state => state.imageExtender.curRatioName);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creationList = useSelector(state => state.common.creationList);
    const setImageRect = (rect, direction) => {
        dispatch(FJActionImageExtender.setImageRectAction(rect, direction));
    };
    return (
        <FJMobileImageExtenderCreation
            uploadImageInfo={uploadImageInfo}
            boardSize={boardSize}
            imageRect={imageRect}
            setImageRect={setImageRect}
            curRatioName={curRatioName}
            taskStatus={taskStatus}
            creationList={creationList}
        />
    );
};

export default FJMobileImageExtenderCreationContainer;
